import axios from "axios";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// material-ui icons
import { Add, Message, Send } from "@mui/icons-material";

import { Link } from "react-router";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import { toast } from "react-toastify";

class Index extends React.Component {
  jamezzTable = React.createRef();

  handleResend = (row) => {
    let id = row[0];

    axios.get("/core/notifications/setstatus?status=not_send&id=" + id).then((response) => {
      toast.success(
        <TranslationWrapper tDefault={"Bericht is succesvol verzonden"} tKey={"notifications.message.resend.success"} />
      );

      this.jamezzTable.current?.refreshData();
    });
  };

  handleCustomStatus = (item) => {
    switch (item.status) {
      case 0:
        return <TranslationWrapper tDefault={"Niet verzonden"} tKey={"notifications.status.not_send"} />;
      case 1:
        return <TranslationWrapper tDefault={"Verzonden"} tKey={"notifications.status.send"} />;
      case 2:
        return <TranslationWrapper tDefault={"Gezien"} tKey={"notifications.status.read"} />;
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Berichten"} tKey={"notifications.pagetitle"} />} />

        <GridContainer>
          <GridItem xs={12}>
            {this.props.vestiging_id ? (
              <AuthenticationWrapper permissionKey={"notifications.create"}>
                <Link to={"./create"}>
                  <Button className={classes.marginRight} color={"success"}>
                    <Add className={classes.icons} />{" "}
                    <TranslationWrapper tDefault={"Nieuw bericht"} tKey={"notifications.nieuw.item"} />
                  </Button>
                </Link>
              </AuthenticationWrapper>
            ) : null}
          </GridItem>
        </GridContainer>

        <GridContainer>
          <VestigingenFilter />
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Send,
                  tooltip: (
                    <TranslationWrapper
                      tDefault={"Verzend opnieuw"}
                      tKey={"notifications.notifications.tooltip.resend"}
                    />
                  ),
                  action: this.handleResend,
                },
              ]}
              dataMapping={[
                { dbfield: "id", editable: false },
                { dbfield: "type", editable: false },
                { dbfield: "titel", editable: false },
                { dbfield: "is_actief", editable: true, inputtype: "Switch" },
                { customData: this.handleCustomStatus },
              ]}
              dbfields={"id,type,titel,is_actief,status"}
              editLink={"./:id/edit"}
              editLinkPermission={"notifications/:id/edit"}
              fetchUrl={"core/notifications"}
              filters={this.props.filters}
              headerIcon={<Message />}
              headers={[
                {
                  label: getTranslation("notifications.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("notifications.table.type", "Type"),
                  sortable: true,
                  sortKey: "type",
                },
                {
                  label: getTranslation("notifications.table.titel", "Titel"),
                  sortable: true,
                  sortKey: "titel",
                },
                {
                  label: getTranslation("notifications.table.is_actief", "Actief"),
                  sortable: false,
                },
                {
                  label: getTranslation("notifications.table.status", "Status"),
                  sortable: false,
                },
              ]}
              reduxKey={"notifications"}
              ref={this.jamezzTable}
              tableTitle={<TranslationWrapper tDefault={"Notifications"} tKey={"notifications.table.header"} />}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

Index.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  return {
    filters: getVestigingFilterState(state, true),
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, vestigingStyle));
